<template>
  <div class="back">
    <q-icon name="fas fa-chevron-left" class="back__icon" />
    Назад
    <PopupConfirm
      v-if="!!this.approve && this.approveMode"
      :title="this.approveTitle || 'Подтвердите действие'"
      :approve="this.approve"
    />
  </div>
</template>

<script>
import PopupConfirm from "@/components/common/PopupConfirm";
export default {
  name: "BackBtn",
  components: {PopupConfirm},
  props: ['approve', 'approveTitle', 'approveMode']
}
</script>

<style scoped lang="scss">
.back {
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  width: fit-content;
  transition: all 0.4s;
  font-size: 14px;
  font-weight: 400;
  color: #4B5563;

  &:hover {
    color: #0a41b8;

    .back__icon {
      color: #0a41b8;
    }
  }
  &__icon {
    color: #4B5563;
    transition: all .4s;
  }
}
</style>
